"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _homepageCarSelector = _interopRequireDefault(require("../styles/homepage-car-selector.css"));
var ComponentTitle = function ComponentTitle(_ref) {
  var theme = _ref.theme,
    sectionTitle = _ref.sectionTitle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.componentTitle + " " + _homepageCarSelector["default"].sectionTitle + " " + _homepageCarSelector["default"].title
  }, /*#__PURE__*/_react["default"].createElement("h2", null, sectionTitle));
};
ComponentTitle.displayName = 'ComponentTitle';
var _default = exports["default"] = ComponentTitle;